import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontally32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFlipHorizontally32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 13.007H5V9.003a4 4 0 0 1 4.888-3.9l14 3.188a4 4 0 0 1 3.112 3.9v.816h-2v-.816a2 2 0 0 0-1.556-1.95l-14-3.188A2 2 0 0 0 7 9.003zm-2 9.99v-3.985h2v3.985a2 2 0 0 0 2.444 1.95l14-3.188A2 2 0 0 0 25 19.809v-.797h2v.797a4 4 0 0 1-3.112 3.9l-14 3.188A4 4 0 0 1 5 22.997M28 17a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontally32);
